import React, {useContext, useEffect, useState} from "react";
import { getMoengage } from "../../utils/moengage.js";
import { useLocation, useNavigate } from "react-router-dom";
import rejectedSvg from "../../assets/svg/EPL_think_svg/Folded_Hands.svg";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { ErrorWrapper } from "./_styles/ErrorWrapper";
import { GetCustomerDetailsContext } from "../../App";
import { isStageLogin } from "../../shared/validations/StageLogin";

function Rejected() {
  const moengage = getMoengage();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const source = location.pathname.split("/")[1];
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [isMobileApplication, setIsMobileApplication] = useState(sessionStorage.getItem("mobileApplication") === "TRUE")
  sessionStorage.clear();

  useEffect(() => {
    // moengage?.add_unique_user_id(customerDetails.Data.uuid);

    isStageLogin(   
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    const message = customerDetails.Data.message;
    const cleanedMessage = message.replace(/[A-Z0-9]{10}/, "");
    // console.log(cleanedMessage);

      setTimeout(function() {
        moengage?.track_event("rejection", {
          rejection_status: true,
          rejection_message: cleanedMessage,
          journey_name: customerDetails.source,
        });
      }, 1000);
  }, []);

  return (
    <>
      <ProgressBar showProgress={false} currentStep={0} />
      <AfterLoginLayoutWrapper>
        <ErrorWrapper className="first-child">
          <Title
            id="pageTitle"
            className="pageTitle"
            text={`We are sorry!`}
            visible={true}
            clickable={false}
            style={{
              fontSize: "24px",
            }}
          />
          <div style={{
            padding: "0px 10px",
            margin: "20px",
            // backgroundColor: "red",
            textAlign: "center",
          }}>
            <SubTitle 
              id="pageSubTitle"
              className="pageSubTitle"
              text={"We are unable to process your loan application further."}
              style={{
                fontSize: "20px",
              }}
            />
          </div>
          <div className="image">
            {/* <img height={125} width={131} src={rejectedSvg} alt="ABFL_Application_Rejected" /> */}
          </div>
        </ErrorWrapper>
        {!isMobileApplication ? (
          <>
            <div className="bottomDiv only-btn">
              <Button
                id="ProceedBtn"
                className="Btn ProceedBtn"
                disabled={false}
                onClick={() => {
                  const updated = customerDetails;
                  updated.stage = "";
                  updated.Data = null;
                  updated.application_form_number = null;
                  setCustomerDetails({
                    ...updated,
                  });
                  var route = getRouteFromLoanStageService({
                    source: source,
                    stage: "",
                  });
                  // // console.log("stage: ", customerDetails.stage);
                  // console.log("route: ", route);
                  navigate(`${route}`, {
                    replace: true,
                  });
                }}
                text={"Home"}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </AfterLoginLayoutWrapper>
    </>
  );
}

export default Rejected;
